<template>
	<div
		class="border-l-4 mb-8"
		:class="{
			'border-gray-300': state == 1,
			'border-top': state == 2 || state == 3,
			'border-green-800': state == 4
		}"
		v-if="state < 5"
	>
		<div
			class="border border-l-0 bg-white text-black p-4 sm:py-5 sm:px-6"
			:class="{
				'border-gray-300': state == 1,
				'border-top': state == 2 || state == 3,
				'border-green-800': state == 4
			}"
		>
			<modal
				:visible="state1.modalVisible"
				:hideButton="true"
				:buttons="state1.modalButtons"
				headline="Kunne ikke finde dine oplysninger"
				@close="state1.modalVisible = false"
			>
				<p>
					Vi kunne desværre ikke finde dine oplysninger. Kontroller mobil nr.
					eller udfyld oplysningerne manuelt.
				</p>
			</modal>
			<modal
				:visible="state2.modalVisible"
				:hideButton="true"
				:buttons="state2.modalButtons"
				headline="Kunne ikke finde dine oplysninger"
				@close="state2.modalVisible = false"
			>
				<p>
					Du har ikke tilmeldt nogen med den fødselsdato inden for de seneste 12
					måneder, og kan derfor ikke bruge hurtig udfyldning.
				</p>
			</modal>
			<modal
				:visible="birthDayIsInvalid"
				headline="Udfyld venligst din fødselsdato korrekt"
				@close="birthDayIsInvalid = false"
			>
				<p>
					Vi kunne ikke genkende formatet i din fødselsdato. Udfyld venligst i
					formatet dd/mm/åååå fx. 31/12/2000
				</p>
			</modal>
			<modal
				:visible="state3.modalVisible"
				:hideButton="true"
				:buttons="state3.modalButtons"
				headline="Mobilkoden er ikke korrekt"
				@close="state3.modalVisible = false"
			>
				<p>
					Kontroller at du har tastet mobilkoden korrekt. Mobilkoden er sendt
					til dit telefonnummer i en SMS.
				</p>
			</modal>
			<div v-show="state == 1">
				<div>
					<b>Spar tid!</b>
					Angiv dit mobilnummer for at bestille med dine gemte oplysninger
				</div>
				<div class="mt-2">
					<form class="flex-col sm:flex-row space-y-4 sm:space-y-0 sm:space-x-4 flex" @submit.prevent="validatePhone">
						<span>
							<input
								type="tel"
								inputmode="decimal"
								v-model="phone"
								placeholder="Hvad er dit mobilnummer?"
								class="input-text w-full"
								ref="mobile"
							/>
						</span>
						<span>
							<button
								type="submit"
								class="block border-0 rounded-sm bg-top text-top-text px-2 sm:px-12 py-3 w-full"
							>
								<spinner v-if="loading"></spinner>
								<span v-else>Næste</span>
							</button>
						</span>
					</form>
				</div>
			</div>
			<div v-show="state == 2">
				<div>
					<svg
						width="20"
						height="20"
						fill="currentColor"
						class="mr-4 text-top"
						xmlns="http://www.w3.org/2000/svg"
					>
						<path
							fill-rule="evenodd"
							clip-rule="evenodd"
							d="M10 0C4.48 0 0 4.48 0 10s4.48 10 10 10 10-4.48 10-10S15.52 0 10 0zM9 15V9h2v6H9zM9 5v2h2V5H9z"
						/>
					</svg>
					<b>Indtast deltagerens fødselsdag</b>, så vi kan hente de rigtige
					oplysninger.
				</div>
				<div class="mt-2">
					<form class="flex-col sm:flex-row space-y-4 sm:space-y-0 sm:space-x-4 flex" @submit.prevent="validateBirthDay">
						<span>
							<input
								type="tel"
								inputmode="decimal"
								placeholder="Hvad er deltagerens fødselsdag?"
								class="input-text w-full"
								ref="birthDay"
								v-model="birthDay"
								v-mask="'##/##/####'"
							/><br />
							<span class="text-xs">F.eks. 23/11/1975</span>
						</span>
						<span>
							<button
								type="submit"
								class="block border-0 rounded-sm bg-top text-top-text px-2 sm:px-12 py-3 w-full"
							>
								<spinner v-if="loading"></spinner>
								<span v-else>Færdig</span>
							</button>
						</span>
					</form>
				</div>
			</div>
			<div v-show="state == 3">
				<div>
					Vi har sendt dig en sikkerhedskode på dit mobil nr. Indtast koden og
					bekræft den.
				</div>
				<div class="mt-2">
					<form class="flex-col sm:flex-row space-y-4 sm:space-y-0 sm:space-x-4 flex" @submit.prevent="validateTwoFA">
						<span>
							<input
								type="tel"
								inputmode="decimal"
								placeholder="Indtast mobilkoden (6 cifre)"
								class="input-text w-full"
								ref="twoFa"
								v-model="twoFa"
								v-mask="'######'"
								autocomplete="one-time-code"
							/>
						</span>
						<span>
							<button
								type="submit"
								class="block border-0 rounded-sm bg-top text-top-text px-2 sm:px-12 py-3 w-full"
							>
								<spinner v-if="loading"></spinner>
								<span v-else>Bekræft</span>
							</button>
						</span>
					</form>
				</div>
			</div>
			<div v-show="state == 4">
				<div>
					<svg
						width="17"
						height="13"
						fill="currentColor"
						class="mr-4 text-green-800"
						xmlns="http://www.w3.org/2000/svg"
					>
						<path
							fill-rule="evenodd"
							clip-rule="evenodd"
							d="M5.707 9.293L15 0l1.414 1.414L5.707 12.121 0 6.414 1.414 5l4.293 4.293z"
						/>
					</svg>
					<b>{{ participantName }}s</b> oplysninger er blevet udfyldt nedenfor.
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import { mask } from "vue-the-mask";
import axios from "axios";
var querystring = require("querystring");

export default {
	data: function() {
		return {
			state: 1,
			phone: "",
			birthDayIsInvalid: false,
			participantName: "",
			birthDay: "",
			twoFa: "",
			loading: false,
			state1: {
				modalVisible: false,
				modalButtons: [
					{
						action: () => {
							this.state1.modalVisible = false;
							this.$nextTick(() => this.$refs.mobile.focus());
						},
						text: "Mit nummer ser forkert ud, jeg prøver igen",
						class:
							"border-gray-400 bg-white text-black px-4 py-2 ml-4 mb-2 border"
					},
					{
						action: () => {
							this.state1.modalVisible = false;
							this.state = 5;
						},
						text: "Jeg udfylder oplysningerne manuelt",
						class:
							"border-gray-400 bg-white text-black px-4 py-2 ml-4 mb-2 border"
					}
				]
			},
			state2: {
				modalVisible: false,
				modalButtons: [
					{
						action: () => {
							this.state2.modalVisible = false;
							this.$nextTick(() => this.$refs.birthDay.focus());
						},
						text: "Min fødselsdato ser forkert ud, jeg prøver igen",
						class:
							"border-gray-400 bg-white text-black px-4 py-2 ml-4 mb-2 border"
					},
					{
						action: () => {
							this.state2.modalVisible = false;
							this.state = 5;
						},
						text: "Jeg udfylder oplysningerne manuelt",
						class:
							"border-gray-400 bg-white text-black px-4 py-2 ml-4 mb-2 border"
					}
				]
			},
			state3: {
				modalVisible: false,
				modalButtons: [
					{
						action: () => {
							this.state3.modalVisible = false;
							this.$nextTick(() => this.$refs.twoFa.focus());
						},
						text: "Prøv igen",
						class:
							"border-gray-400 bg-white text-black px-4 py-2 ml-4 mb-2 border"
					},
					{
						action: () => {
							this.state3.modalVisible = false;
							this.state = 5;
						},
						text: "Udfylder oplysningerne manuelt",
						class:
							"border-gray-400 bg-white text-black px-4 py-2 ml-4 mb-2 border"
					}
				]
			}
		};
	},
	props: {
		orderLines: Array,
		associationGuid: String
	},
	computed: {
		birthDayIsValid: function() {
			return this.birthDay.match(/\d{2}\/\d{2}\/\d{4}/);
		}
	},
	methods: {
		validatePhone: function() {
			this.loading = true;
			axios
				.post(
					"/umbraco/surface/ParticipantLookupSurface/LookupByMobile",
					querystring.stringify({
						mobile: this.phone,
						association: this.associationGuid
					})
				)
				.then(response => {
					this.loading = false;
					if (response.data == 0) {
						this.state1.modalVisible = true;
					} else if (response.data > 1) {
						this.state = 2;
						this.$refs.birthDay.focus();
						this.$nextTick(() => {
							console.log("focus");
							console.log(this.$refs.birthDay);
							console.log(this.$refs);
							this.$refs.birthDay.focus();
						});
					} else {
						this.state = 3;
						this.$nextTick(() => this.$refs.twoFa.focus());
					}
				});
		},

		validateBirthDay: function() {
			if (this.birthDayIsValid) {
				this.loading = true;
				axios
					.post(
						"/umbraco/surface/ParticipantLookupSurface/LookupByMobileAndDOB",
						querystring.stringify({
							mobile: this.phone,
							dob: this.birthDay,
							association: this.associationGuid
						})
					)
					.then(response => {
						this.loading = false;
						if (response.data == "") {
							this.state2.modalVisible = true;
						} else {
							this.state = 3;
							this.$nextTick(() => this.$refs.twoFa.focus());
						}
					});
			} else {
				this.birthDayIsInvalid = true;
			}
		},

		validateTwoFA: function() {
			this.loading = true;
			axios
				.post(
					"/umbraco/surface/ParticipantLookupSurface/GetByMobileAnd2FA",
					querystring.stringify({ mobile: this.phone, twofa: this.twoFa })
				)
				.then(response => {
					this.loading = false;
					if (response.data == "") {
						this.state3.modalVisible = true;
					} else {
						var participant = response.data;
						this.participantName =
							participant.firstName + " " + participant.lastName;

						this.orderLines.map(ol => {
							if (ol.Participants) {
								ol.Participants.map((p, index) => {
									if (index == 0) {
										p.Mobile = participant.mobile;
										p.Phone = participant.phone;
										p.Email = participant.email;
										p.FirstName = participant.firstName;
										p.LastName = participant.lastName;
										p.DateOfBirthString = participant.dateOfBirth;
										p.Gender = participant.gender;
										p.CompanyName = participant.companyName;
										p.Address = participant.address;
										p.Zip = participant.zipcode;
										p.City = participant.city;
									}
								});
							}

							if (ol.Teams) {
								ol.Teams.map(t => {
									if (t.Participants) {
										t.Participants.map((p, index) => {
											if (index == 0) {
												p.Mobile = participant.mobile;
												p.Phone = participant.phone;
												p.Email = participant.email;
												p.FirstName = participant.firstName;
												p.LastName = participant.lastName;
												p.DateOfBirthString = participant.dateOfBirth;
												p.Gender = participant.gender;
											}
											p.CompanyName = participant.companyName;
											p.Address = participant.address;
											p.Zip = participant.zipcode;
											p.City = participant.city;
										});
									}
								});
							}
						});
						this.$store.dispatch("saveBasket", this.$store.getters.basket);
						if (this.$store.getters.hasTriedToCheckout) {
							this.$store.dispatch("resetTryingToCheckout");
							this.$store.dispatch("tryingToCheckout");
						}
						this.state = 4;
						sessionStorage.setItem(
							"participantLookup",
							JSON.stringify(response)
						);
					}
				});
		}
	},
	created: function() {
		if (sessionStorage.getItem("participantLookup")) {
			if (
				this.orderLines.filter(o => {
					if (o.Participants) {
						return (
							o.Participants.filter(p => p.FirstName && p.FirstName != "")
								.length > 0
						);
					}
					if (o.Teams) {
						return (
							o.Teams.filter(
								t =>
									t.Participants &&
									t.Participants.filter(p => p.FirstName && p.FirstName != "")
										.length > 0
							).length > 0
						);
					}
				}).length > 0
			) {
				this.state = 5;
			} else {
				sessionStorage.removeItem("participantLookup");
			}
		}
	},
	directives: {
		mask
	}
};
</script>
